export default __webpack_public_path__ + "static/media/principles_customer_first.0e559f7c.png";